export default "__VITE_ASSET__HU7VIB6f__"